import React from 'react'

const FilterButton = ({label, name, value, currentStatus, onChange}) => (
  <div className="bulkFilterButton--wrapper">
    <input
      type="radio"
      name={name}
      id={name + value}
      value={value}
      checked={currentStatus === value}
      onChange={() => onChange(value)}
    />
    <label htmlFor={name + value}>{label}</label>
  </div>
)

export default FilterButton


// WEBPACK FOOTER //
// ./src/ui/active-filter/view/filter-button.jsx